import { WebSocketEventTypeEnum } from '../../enums/WebSocketEventTypeEnum';
import type Notification from '../../interfaces/Notification';

/** Event types that get a mapped title/icon in the notifications drawer. */
export const DISPLAYABLE_NOTIFICATION_EVENT_TYPES = new Set<string>([
  WebSocketEventTypeEnum.Tags,
  WebSocketEventTypeEnum.Summary,
  WebSocketEventTypeEnum.DocumentClassification,
  WebSocketEventTypeEnum.SharingOperation,
]);

export function isDisplayableNotificationEventType(eventType: unknown): boolean {
  if (eventType == null) {
    return false;
  }
  const normalized = String(eventType).trim().toLowerCase();
  return normalized !== '' && DISPLAYABLE_NOTIFICATION_EVENT_TYPES.has(normalized);
}

/** Drop stale/unknown notifications (e.g. pre-whitelist localStorage leftovers). */
export function pruneUndisplayableNotifications(notifications: unknown): Notification[] {
  if (!Array.isArray(notifications)) {
    return [];
  }
  return notifications.filter(
    (notification): notification is Notification =>
      notification != null &&
      typeof notification === 'object' &&
      isDisplayableNotificationEventType((notification as Notification).eventType),
  );
}
